export const deviceDashboardTypes = {
    UPDATE_REQUEST: "DEVICE_DASHBOARD_UPDATE_REQUEST",
    FETCH_RSSI_HISTORY_REQUEST: "DEVICE_DASHBOARD_FETCH_RSSI_HISTORY_REQUEST",
    FETCH_RSSI_HISTORY_SUCCESS: "DEVICE_DASHBOARD_FETCH_RSSI_HISTORY_SUCCESS",
    FETCH_RSSI_HISTORY_FAILURE: "DEVICE_DASHBOARD_FETCH_RSSI_HISTORY_FAILURE",
    FETCH_LOCATION_HISTORY_REQUEST: "DEVICE_DASHBOARD_FETCH_LOCATION_HISTORY_REQUEST",
    FETCH_LOCATION_HISTORY_SUCCESS: "DEVICE_DASHBOARD_FETCH_LOCATION_HISTORY_SUCCESS",
    FETCH_LOCATION_HISTORY_FAILURE: "DEVICE_DASHBOARD_FETCH_LOCATION_HISTORY_FAILURE",
    FETCH_BATTERY_HISTORY_REQUEST: "DEVICE_DASHBOARD_FETCH_BATTERY_HISTORY_REQUEST",
    FETCH_BATTERY_HISTORY_SUCCESS: "DEVICE_DASHBOARD_FETCH_BATTERY_HISTORY_SUCCESS",
    FETCH_BATTERY_HISTORY_FAILURE: "DEVICE_DASHBOARD_FETCH_BATTERY_HISTORY_FAILURE",
    FETCH_ACCLERATION_HISTORY_REQUEST: "DEVICE_DASHBOARD_FETCH_ACCLERATION_HISTORY_REQUEST",
    FETCH_ACCLERATION_HISTORY_SUCCESS: "DEVICE_DASHBOARD_FETCH_ACCLERATION_HISTORY_SUCCESS",
    FETCH_ACCLERATION_HISTORY_FAILURE: "DEVICE_DASHBOARD_FETCH_ACCLERATION_HISTORY_FAILURE",
    FETCH_GATEWAY_TELEMETRY_HISTORY_REQUEST: "DEVICE_DASHBOARD_FETCH_GATEWAY_TELEMETRY_HISTORY_REQUEST",
    FETCH_GATEWAY_TELEMETRY_HISTORY_SUCCESS: "DEVICE_DASHBOARD_FETCH_GATEWAY_TELEMETRY_HISTORY_SUCCESS",
    FETCH_GATEWAY_TELEMETRY_HISTORY_FAILURE: "DEVICE_DASHBOARD_FETCH_GATEWAY_TELEMETRY_HISTORY_FAILURE",
    FETCH_SIGNAL_HISTORY_REQUEST: "DEVICE_DASHBOARD_FETCH_SIGNAL_HISTORY_REQUEST",
    FETCH_SIGNAL_HISTORY_SUCCESS: "DEVICE_DASHBOARD_FETCH_SIGNAL_HISTORY_SUCCESS",
    FETCH_SIGNAL_HISTORY_FAILURE: "DEVICE_DASHBOARD_FETCH_SIGNAL_HISTORY_FAILURE",
    FETCH_ASSET_HISTORY_REQUEST: "DEVICE_DASHBOARD_FETCH_ASSET_HISTORY_REQUEST",
    FETCH_ASSET_HISTORY_SUCCESS: "DEVICE_DASHBOARD_FETCH_ASSET_HISTORY_SUCCESS",
    FETCH_ASSET_HISTORY_FAILURE: "DEVICE_DASHBOARD_FETCH_ASSET_HISTORY_FAILURE",
    FETCH_SHOCK_ALARM_HISTORY_REQUEST: "DEVICE_DASHBOARD_FETCH_SHOCK_ALARM_HISTORY_REQUEST",
    FETCH_SHOCK_ALARM_HISTORY_SUCCESS: "DEVICE_DASHBOARD_FETCH_SHOCK_ALARM_HISTORY_SUCCESS",
    FETCH_SHOCK_ALARM_HISTORY_FAILURE: "DEVICE_DASHBOARD_FETCH_SHOCK_ALARM_HISTORY_FAILURE",
};

export const updateRequest = (req) => ({
    type: deviceDashboardTypes.UPDATE_REQUEST,
    payload: req
});

export const fetchRSSIHistoryRequest = (req) => ({
    type: deviceDashboardTypes.FETCH_RSSI_HISTORY_REQUEST,
    payload: req
});

export const fetchRSSIHistorySuccess = (resp) => ({
    type: deviceDashboardTypes.FETCH_RSSI_HISTORY_SUCCESS,
    payload: resp
});

export const fetchRSSIHistoryFailure = (error) => ({
    type: deviceDashboardTypes.FETCH_LOCATION_HISTORY_FAILURE,
    payload: error
});

export const fetchLocationHistoryRequest = (req) => ({
    type: deviceDashboardTypes.FETCH_LOCATION_HISTORY_REQUEST,
    payload: req
});


export const fetchLocationHistorySuccess = (resp) => ({
    type: deviceDashboardTypes.FETCH_LOCATION_HISTORY_SUCCESS,
    payload: resp
});

export const fetchLocationHistoryFailure = (error) => ({
    type: deviceDashboardTypes.FETCH_LOCATION_HISTORY_FAILURE,
    payload: error
});

export const fetchBatteryHistoryRequest = (req) => ({
    type: deviceDashboardTypes.FETCH_BATTERY_HISTORY_REQUEST,
    payload: req
});
export const fetchAssetHistoryRequest = (req) => ({
    type: deviceDashboardTypes.FETCH_ASSET_HISTORY_REQUEST,
    payload: req
});
export const fetchAssetHistorySuccess = (resp) => ({
    type: deviceDashboardTypes.FETCH_ASSET_HISTORY_SUCCESS,
    payload: resp
});
export const fetchAssetHistoryFailure = (error) => ({
    type: deviceDashboardTypes.FETCH_ASSET_HISTORY_FAILURE,
    payload: error
});

export const fetchBatteryHistorySuccess = (resp) => ({
    type: deviceDashboardTypes.FETCH_BATTERY_HISTORY_SUCCESS,
    payload: resp
});

export const fetchBatteryHistoryFailure = (error) => ({
    type: deviceDashboardTypes.FETCH_BATTERY_HISTORY_FAILURE,
    payload: error
});

export const fetchAcclerationHistoryRequest = (req) => ({
    type: deviceDashboardTypes.FETCH_ACCLERATION_HISTORY_REQUEST,
    payload: req
});

export const fetchAcclerationHistorySuccess = (resp) => ({
    type: deviceDashboardTypes.FETCH_ACCLERATION_HISTORY_SUCCESS,
    payload: resp
});

export const fetchAcclerationHistoryFailure = (error) => ({
    type: deviceDashboardTypes.FETCH_ACCLERATION_HISTORY_FAILURE,
    payload: error
});

export const fetchGatewayTelemetryHistoryRequest = (req) => ({
    type: deviceDashboardTypes.FETCH_GATEWAY_TELEMETRY_HISTORY_REQUEST,
    payload: req
});

export const fetchGatewayTelemetryHistorySuccess = (resp) => ({
    type: deviceDashboardTypes.FETCH_GATEWAY_TELEMETRY_HISTORY_SUCCESS,
    payload: resp
});

export const fetchGatewayTelemetryHistoryFailure = (error) => ({
    type: deviceDashboardTypes.FETCH_GATEWAY_TELEMETRY_HISTORY_FAILURE,
    payload: error
});

export const fetchSignalHistoryRequest = (req) => ({
    type: deviceDashboardTypes.FETCH_SIGNAL_HISTORY_REQUEST,
    payload: req
});

export const fetchSignalHistorySuccess = (resp) => ({
    type: deviceDashboardTypes.FETCH_SIGNAL_HISTORY_SUCCESS,
    payload: resp
});

export const fetchSignalHistoryFailure = (error) => ({
    type: deviceDashboardTypes.FETCH_SIGNAL_HISTORY_FAILURE,
    payload: error
});

export const fetchShockAlarmHistoryRequest = (req) => ({
    type: deviceDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_REQUEST,
    payload: req
});

export const fetchShockAlarmHistorySuccess = (resp) => ({
    type: deviceDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_SUCCESS,
    payload: resp
});

export const fetchShockAlarmHistoryFailure = (error) => ({
    type: deviceDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_FAILURE,
    payload: error
});